module.exports = __webpack_public_path__ + "img/3.9de27df0.png";